export type RulesConfigurationFormType = {
    name: string;
    service_type_ids: number[];
    is_moment: boolean;
    is_airport: boolean;
    is_priority: boolean;
    stages: StageFormType[];
}

export type StageFormType = {
    stage_id: number | undefined;
    has_polygon: boolean;
    is_countdown: boolean;
    semaphores: SemaphoreFormType[];
}

export type SemaphoreFormType = {
    polygon_zone_id?: number;
    semaphore_levels: SemaphoreLevelFormType[];
}

export type SemaphoreLevelFormType = {
    semaphore_color_key: string;
    threshold_minutes: number;
    semaphore_message_templates: MessageFormType;
}

export type MessageFormType = {
    id?: number;
    channel_keys: string[] | null;
    title: string;
    body: string;
}


export enum StepDirection {
    NEXT = 'next',
    PREV = 'prev',
}

export enum steps {
    grouperAndServiceType = 'grouperAndServiceType',
    travelStatus = 'travelStatus',
}

export type Step = {
    step: steps;
    direction: StepDirection;
}